import firebase from "firebase/app";
import moment from "moment";
import { getCookie } from "../cookies";
import { fetchIpAddress } from "../../services/getIpAddress";
import { getBrowserName } from "../getBrowserName";

// Firebase configuration from environment variables
const firebaseConfigLogs = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// const firebaseConfigLogs = {
//   apiKey: "AIzaSyBZaw9-UA597SHTXjIUr3beMLMqkpGStkg",
//   authDomain: "presto-express-logs.firebaseapp.com",
//   databaseURL:
//     "https://presto-express-logs-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "presto-express-logs",
//   storageBucket: "presto-express-logs.appspot.com",
//   messagingSenderId: "11324638571",
//   appId: "1:11324638571:web:c74cb4e710bd39b967782e",
//   measurementId: "G-VG9XD6D9W7",
// };

export const saveLogs = async (data: any, app: any, locationId: any) => {
  try {
    const browserName = getBrowserName();
    const firebaseUser: any = getCookie("firebaseUser");
    const app2 =
      firebase.apps.find((app) => app.name === "SecondProject") ||
      firebase.initializeApp(firebaseConfigLogs, "SecondProject");

    // Get a reference to the database
    const database = app2.database().ref();
    const updatedData = data;
    const res = await fetchIpAddress();
    updatedData.date = moment().format("YYYY-MM-DD HH:mm:ss");
    if (firebaseUser && JSON.parse(firebaseUser)?.name) {
      updatedData.metadata["changedBy"] = JSON.parse(firebaseUser)?.name;
    } else {
      updatedData.metadata["changedBy"] = JSON.parse(firebaseUser)?.email;
    }
    updatedData.metadata["browser"] = browserName;
    updatedData.metadata["ip"] = res.data.ip;
    console.log("sdfgdsgadfasdasfag", updatedData);
    // Specify the desired path
    const logsRef = database
      .child("logs")
      .child(moment().format("YYYYMMDD"))
      .child(app)
      .child(locationId);
    console.log("app value:", typeof app, app);
    // Push the updated data to a new child node
    logsRef.push(updatedData, (error) => {
      if (error) {
        console.error("Error saving log:", error);
      } else {
        console.log("Log saved at:", logsRef.toString());
      }
    });
  } catch (err) {
    console.error("Error in saveLogs:", err);
  }
};
